module.exports = __webpack_public_path__ + "static/img/hosoda_02.ded0e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/hosoda_02.png
// module id = Q1kb
// module chunks = 0